import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const c3PrajaTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#49224e',
    },
    secondary: {
      main: '#b8cb24',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#49224e',
    },
  },
};
